export default __webpack_public_path__ + "static/media/indirectuser.02562d43.png";